import { CustomAvatarOptions } from "@azure/communication-react";
import { Icon, Persona } from "@fluentui/react";
import { Avatar } from "@fluentui/react-components";
import { useChatStyle } from "./style";

const useOnRenderAvatar = () => {
	const classes = useChatStyle();

	const onRenderAvatar = (_userId?: string, options?: CustomAvatarOptions) => {
		return (
			<Persona
				styles={{
					root: {
						width: "32px",
						height: "32px",
					},
				}}
				onRenderPersonaCoin={() => {
					return (
						<Avatar
							size={32}
							color="brand"
							icon={<Icon iconName="Contact" className={classes.avatar} />}
							name={options?.text}
						/>
					);
				}}
			/>
		);
	};

	return onRenderAvatar;
};

export default useOnRenderAvatar;
